export const GET_PROJECT_SETTINGS_TEMPLATE_REQUEST = "GET_PROJECT_SETTINGS_TEMPLATE_REQUEST";
export const GET_PROJECT_SETTINGS_TEMPLATE_SUCCESS = "GET_PROJECT_SETTINGS_TEMPLATE_SUCCESS";
export const GET_PROJECT_SETTINGS_TEMPLATE_FAILURE = "GET_PROJECT_SETTINGS_TEMPLATE_FAILURE";

export const UPDATE_PROJECT_SETTINGS_TEMPLATE_REQUEST = "UPDATE_PROJECT_SETTINGS_TEMPLATE_REQUEST";
export const UPDATE_PROJECT_SETTINGS_TEMPLATE_SUCCESS = "UPDATE_PROJECT_SETTINGS_TEMPLATE_SUCCESS";
export const UPDATE_PROJECT_SETTINGS_TEMPLATE_FAILURE = "UPDATE_PROJECT_SETTINGS_TEMPLATE_FAILURE";

export const ADD_PROJECT_SETTINGS_TEMPLATE_REQUEST = "ADD_PROJECT_SETTINGS_TEMPLATE_REQUEST";
export const ADD_PROJECT_SETTINGS_TEMPLATE_SUCCESS = "ADD_PROJECT_SETTINGS_TEMPLATE_SUCCESS";
export const ADD_PROJECT_SETTINGS_TEMPLATE_FAILURE = "ADD_PROJECT_SETTINGS_TEMPLATE_FAILURE";

export const DELETE_PROJECT_SETTINGS_TEMPLATE_REQUEST = "DELETE_PROJECT_SETTINGS_TEMPLATE_REQUEST";
export const DELETE_PROJECT_SETTINGS_TEMPLATE_SUCCESS = "DELETE_PROJECT_SETTINGS_TEMPLATE_SUCCESS";
export const DELETE_PROJECT_SETTINGS_TEMPLATE_FAILURE = "DELETE_PROJECT_SETTINGS_TEMPLATE_FAILURE";

export const GET_PROJECT_SETTINGS_TEMPLATE_BY_ID_REQUEST = "GET_PROJECT_SETTINGS_TEMPLATE_BY_ID_REQUEST";
export const GET_PROJECT_SETTINGS_TEMPLATE_BY_ID_SUCCESS = "GET_PROJECT_SETTINGS_TEMPLATE_BY_ID_SUCCESS";
export const GET_PROJECT_SETTINGS_TEMPLATE_BY_ID_FAILURE = "GET_PROJECT_SETTINGS_TEMPLATE_BY_ID_FAILURE";

export const UPDATE_SETTINGS_ENTITY_PARAMS_SUCCESS = "UPDATE_SETTINGS_ENTITY_PARAMS_SUCCESS";
export const UPDATE_SETTINGS_ENTITY_PARAMS_FAILURE = "UPDATE_SETTINGS_ENTITY_PARAMS_FAILURE";
